import React from "react";
import { MessageCircle, ArrowRight } from "lucide-react";

function scrollToApply() {
    const el = document.getElementById("bewerbung");
    if (el) window.scrollTo({ top: el.offsetTop - 72, behavior: "smooth" });
}

export default function StickyMobileCTA() {
    return (
        <div
            data-testid="sticky-mobile-cta"
            className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-md border-t border-moebus-border shadow-[0_-8px_24px_-8px_rgba(15,23,42,0.15)]"
            style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
        >
            <div className="flex items-stretch gap-2 p-3">
                <button
                    data-testid="mobile-cta-apply"
                    onClick={scrollToApply}
                    className="flex-1 inline-flex items-center justify-center gap-2 bg-moebus-green hover:bg-emerald-700 text-white font-medium px-4 py-3 rounded-md shadow-md text-sm"
                >
                    Jetzt bewerben
                    <ArrowRight size={16} />
                </button>
                <a
                    data-testid="mobile-cta-whatsapp"
                    href="https://wa.me/49711808086"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="WhatsApp Kontakt"
                    className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1da851] text-white font-medium px-4 py-3 rounded-md shadow-md text-sm"
                >
                    <MessageCircle size={18} strokeWidth={2} />
                    <span className="font-semibold">WhatsApp</span>
                </a>
            </div>
        </div>
    );
}
